//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PatternTextField from "./_patternText";
export default {
  components: {
    // Need to start with `fields-` to enable jsonlogic in `styles.js#_linkFieldModels`
    "fields-patternText": PatternTextField
  },
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      value: null
    };
  } // methods: {
  //   $ready() {
  //     this.value = this.spec.value.slice(0, 16);
  //     // this.value = moment(this.spec.value).format('YYYY-MM-DDThh:mm')
  //   }
  // }

};